import { render, staticRenderFns } from "./envelope-detail.vue?vue&type=template&id=21735b64"
import script from "./envelope-detail.vue?vue&type=script&lang=js"
export * from "./envelope-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports